import { render, staticRenderFns } from "./VetApprovals.vue?vue&type=template&id=2987a770&"
import script from "./VetApprovals.vue?vue&type=script&lang=js&"
export * from "./VetApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports